import { ObjectPreviewCanvas } from "@rastreabilidadebrasil/tageditor";

export default function ShapeItem (props: { children?: JSX.Element, forma: string }) {

    return (
        <div className="shape-item-container">
            <ObjectPreviewCanvas json={props.forma} scale={0.7} />
        </div>
    )
}